import { render, staticRenderFns } from "./UsersGroupsInput.vue?vue&type=template&id=3abc2ce2&scoped=true&"
import script from "./UsersGroupsInput.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsInput.vue?vue&type=script&lang=js&"
import style0 from "./UsersGroupsInput.vue?vue&type=style&index=0&id=3abc2ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc2ce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VList,VRow})
